import { authorizedAction } from 'api'
import { ErrorProp } from './'

type IndexRecordResponseProps =
  | {
      success: true
    }
  | {
      success: false
      error: ErrorProp
      message?: string
    }

export type IndexRecordProps = {
  userId?: string
}

export async function indexRecord({
  userId,
}: IndexRecordProps): Promise<IndexRecordResponseProps> {
  try {
    const response = await authorizedAction({
      action: 'Search.IndexRecord',
      body: {
        Username: userId,
      },
    })

    const json = (await response.json()) as IndexRecordResponseProps

    if (json.success) {
      return { success: true }
    } else {
      return {
        success: false,
        error: json.error ?? json.message,
      }
    }
  } catch (e: any) {
    throw e
  }
}
